"use strict";
/**
 * @file Created on 13.07.2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NotificationDocConverter_1 = require("../NotificationDocConverter");
/**
 * @author MHl
 */


var NChangedWindowDTOConverter =
/*#__PURE__*/
function (_NotificationDocConve) {
  _inherits(NChangedWindowDTOConverter, _NotificationDocConve);

  function NChangedWindowDTOConverter() {
    _classCallCheck(this, NChangedWindowDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NChangedWindowDTOConverter).apply(this, arguments));
  }

  return NChangedWindowDTOConverter;
}(NotificationDocConverter_1.NotificationDocConverter);

exports.NChangedWindowDTOConverter = NChangedWindowDTOConverter;